import { render, staticRenderFns } from "./quizScope.vue?vue&type=template&id=39952d38&scoped=true&"
import script from "./quizScope.vue?vue&type=script&lang=js&"
export * from "./quizScope.vue?vue&type=script&lang=js&"
import style0 from "./quizScope.vue?vue&type=style&index=0&id=39952d38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39952d38",
  null
  
)

export default component.exports